import { ApiResponse } from '@interfaces/api';
import { ListingsItemToShip } from '../domain/ListingsItemsToShip';
import { ListingsProductDetails } from '../domain/ListingsProducts';
import { ListingsItemToShipDTO } from '../dtos/ListingsItemsToShipDTO';

const mapItemData = (itemDTO: ListingsItemToShipDTO): ListingsItemToShip => {
  // TODO Only use fields needed in UI
  return {
    productId: itemDTO.productId,
    externalRef: itemDTO.externalRef,
    productName: itemDTO.productName,
    brandName: itemDTO.brandName,
    imageUrl: itemDTO.imageUrl,
    shipByDate: itemDTO.shipByDate,
    daysToShip: itemDTO.daysToShip,
    cancelSaleUrl: itemDTO.cancelSaleUrl,
    shippingLabelUrl: itemDTO.shippingLabelUrl,
    orderConfirmationDate: itemDTO.orderConfirmationDate,
    productPrice: itemDTO.productPrice,
    ezlink: itemDTO.ezlink,
    sold: itemDTO.sold,
    retired: itemDTO.retired,
    unreceived: itemDTO.unreceived,
    stock: itemDTO.stock,
    stock_vdc: itemDTO.stock_vdc,
    currencyRate: itemDTO.currencyRate,
    soldDate: itemDTO.soldDate,
    id_client: itemDTO.id_client,
    sellerEarning: itemDTO.sellerEarning,
    sellerPrice: itemDTO.sellerPrice,
    isDirectShipping: itemDTO.isDirectShipping,
  };
};

export const mapListingsItemsToShipResponse = (dto: ApiResponse<ListingsItemToShipDTO[]>): ListingsItemToShip[] => {
  return dto.data.map((item) => mapItemData(item));
};

export const mapListingsItemsToShipProduct = (item: ListingsItemToShip): ListingsProductDetails => {
  return {
    id: item.productId,
    headline: item.brandName,
    subHeadline: item.productName,
    picturePath: item.imageUrl,
    path: item.ezlink,
    price: item.sellerPrice,
    sellerEarnings: item.sellerEarning,
  };
};
